import React, { useState } from 'react';
import SVGShorts from '../Components/ShortsSVGfinal';
import { useSelector, useDispatch } from 'react-redux';
import ColorsList from '../../src/Common'
import { setSuitPartsList } from '../redux/Slices/MainSlice';

import SavedDesingList from '../../src/Layout/SavedDesingList'

import styled from 'styled-components';
import { FaTimes } from "react-icons/fa"


const PopUpWrapper = styled.div`
top: -1px;
bottom: auto;
min-width: 200px;
width: 25%;
position:absolute;
text-align: left;
background: rgba(255, 255, 255, 0.75);
border: 1px solid;
padding: 10px 10px 20px;
& .colorbox {
	width:25px;
	height:25px;
	display:inline-block
}
`

function RightSide(props) {
	const [isShowColor, setisShowColor] = useState(false)
	const [selector, setselector] = useState('')

	var ColorFiller = useSelector(state => state.auth.SuitPartsList);
	let dispatch = useDispatch();



	const SetSpecificColor = (v) => {



		setisShowColor(true);
		setselector(v);


	}

	const SetColor = (color) => {

		if (selector != '') {
			debugger
			
			setisShowColor(false);
			dispatch(setSuitPartsList({ color, selector }))
		}
		else {
			alert('Please select object.')
		}
		

	}


return (
	<>
		<div style={{ backgroundColor: "rgb(242, 243, 244)" }} className='border roudned p-3 m-3 position-relative'>

			{
				isShowColor === "true" ?
				 <PopUpWrapper>
					<div className='text-end pointer' >	<FaTimes onClick={() => setisShowColor(false)} /></div>
					<div className='my-3'>


						{ColorsList.map(x =>

							<span onClick={() => SetColor(x.value)} className='colorbox' style={{ backgroundColor: "" + x.value + "", color: "" + x.value + "" }}> </span>)
						}
					</div>

				</PopUpWrapper>
					: null
			}

			{/* <div dangerouslySetInnerHTML={{__html:JumperSUITSVG}}></div> */}

			<div>
				{/* <SUITSVG   SetSelector={SetSpecificColor}  /> */}


				{/* <JumperTwoSuitSVG SetSelector={SetSpecificColor} /> */}
				<div id='svgWrapperID'>
						{/*<SVGfinaltest SetSelector={SetSpecificColor}/>*/}
					<SVGShorts SetSelector={SetSpecificColor}/>
					{/* <Shorts /> */}
					

				</div>
				


				<SavedDesingList   />


			</div>




		</div>
	</>
);
}

export default RightSide;